import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-69de3990")
const _hoisted_1 = { class: "relative bg-home bg-center bg-cover w-full h-full min-h-screen" }
const _hoisted_2 = { class: "bg-home__content md:max-w-md px-8 md:px-0 md:ml-24 md:pt-10 md:mb-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "uppercase inline-flex flex-col text-white tracking-widest md:mb-20" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-2xl md:text-4xl md:mb-2" }, "BEM-VINDOS À"),
  /*#__PURE__*/_createElementVNode("span", { class: "md:ml-8 text-3xl md:text-5xl md:mb-2" }, " NEO QUÍMICA "),
  /*#__PURE__*/_createElementVNode("span", { class: "md:ml-16 text-3xl md:text-5xl text-primary underline" }, " ARENA VIRTUAL ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-white text-3xl mb-4" }, "Acesso", -1)
const _hoisted_5 = { class: "grid gap-2" }
const _hoisted_6 = {
  key: 0,
  class: "text-1xl mb-4 mt-4",
  style: {"text-align":"center","color":"red"}
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Acessar ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "text-white text-3xl mb-4" }, "Cadastre-se", -1)
const _hoisted_9 = { class: "flex bg-home__inputs" }
const _hoisted_10 = { class: "grid gap-2" }
const _hoisted_11 = { class: "flex justify-between" }
const _hoisted_12 = { class: "block text-white mb-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "py-2 ml-3" }, " Estou de acordo com o uso dos meus dados pessoais pela Hypera Pharma, Sport Clube Corinthians, empresas afiliadas e/ou parceiros comerciais, durante o período de vigência do meu cadastro, nos termos do aviso de privacidade, para recebimento de notícias e novidades relacionadas ao portal www.neoquímicaarenavirtual.com.br, além de outras comunicações que possam ser de meu interesse.", -1)
const _hoisted_14 = { class: "flex justify-between" }
const _hoisted_15 = { class: "block text-white mb-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "py-2 ml-3" }, " Aceito receber notícias e novidades por SMS.", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-white text-sm" }, "* Preenchimento obrigatório", -1)
const _hoisted_18 = {
  key: 0,
  class: "text-1xl mb-4 mt-4",
  style: {"text-align":"center","color":"red"}
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Cadastrar")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-white text-sm mt-4" }, [
  /*#__PURE__*/_createTextVNode(" * Ao se cadastrar você irá concordar com a nossa "),
  /*#__PURE__*/_createElementVNode("a", {
    style: {"text-decoration":"none","font-weight":"bold"},
    target: "blank",
    href: "https://neoquimicaarenavirtual.com.br/politica-de-privacidade"
  }, "política de privacidade")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h2", { class: "text-white text-3xl mb-4" }, "Confirme seu e-mail", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h4", {
  class: "text-white text-1xl mb-4 mt-4",
  style: {"text-align":"center","cursor":"pointer"}
}, " Enviamos um e-mail de confirmação para seu e-mail cadastrado. ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-white text-sm" }, " * Caso não receba, verifique a caixa de spam ", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Entrar")
const _hoisted_25 = {
  key: 4,
  class: "pb-8"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h2", { class: "text-white text-3xl mb-4" }, "Recupere sua senha", -1)
const _hoisted_27 = { class: "grid gap-2" }
const _hoisted_28 = {
  key: 0,
  class: "text-1xl mb-4 mt-4",
  style: {"text-align":"center","color":"red"}
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Recuperar senha")
const _hoisted_30 = {
  key: 5,
  class: "pb-8"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h2", { class: "text-white text-3xl mb-4" }, "Verifique seu email", -1)
const _hoisted_32 = { class: "grid gap-2" }
const _hoisted_33 = { class: "grid gap-2" }
const _hoisted_34 = {
  key: 0,
  class: "text-1xl mb-4 mt-4",
  style: {"text-align":"center","color":"red"}
}
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Trocar senha")
const _hoisted_36 = {
  key: 6,
  class: "pb-8"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "text-white text-3xl mb-8" }, "Ocorreu um erro", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "text-white mb-8 text-xl" }, "Tente novamente mais tarde", -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Tentar novamente")
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<div class=\"absolute left-0 top-0 w-full h-full overflow-hidden -z-10\" data-v-69de3990><div class=\"transition tl absolute top-0 left-0 w-1/2 md:w-1/3\" data-v-69de3990><img class=\"relative w-full transform -translate-y-2/3 translate-x-1/2\" src=\"/home-tl_shape.svg\" data-v-69de3990></div><div class=\"transition tr absolute hidden md:block top-0 right-0 w-1/4 md:w-1/6\" data-v-69de3990><img class=\"relative w-full transform -translate-y-1/3 -translate-x-1/3\" src=\"/home-tr_shape.svg\" data-v-69de3990></div><div class=\"transition bl absolute bottom-0 left-0 w-2/3 md:w-1/3 overflow-hidden\" data-v-69de3990><img class=\"relative w-full transform translate-y-1/3\" src=\"/home-bl_shape.svg\" data-v-69de3990></div><div class=\"transition br absolute bottom-0 right-0 w-1/2 md:w-1/3 overflow-hidden\" data-v-69de3990><img class=\"relative w-full md:-bottom-16 md:-right-16\" src=\"/home-br_shape.svg\" data-v-69de3990></div></div>", 1)
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 1,
  class: "cookie-popup w-80 absolute bg-white rounded-lg shadow-lg p-6"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createTextVNode(" Usamos cookies para personalizar conteúdos e melhorar a sua experiência. Para mais informações, acesse o nosso "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://www.neoquimica.com.br/politica-privacidade.php"
  }, "Aviso Externo de Privacidade"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_stadium_component = _resolveComponent("stadium-component")!
  const _component_text_field = _resolveComponent("text-field")!
  const _component_large_button = _resolveComponent("large-button")!
  const _component_stadium_background = _resolveComponent("stadium-background")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      false
        ? (_openBlock(), _createBlock(_component_stadium_component, {
            key: 0,
            style: {"position":"absolute","opacity":"0.8"},
            class: "md:mb-8 -z-10"
          }))
        : _createCommentVNode("", true),
      (_ctx.step === 'signin')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["pb-8", { 'mt-16': !_ctx.showBackground }])
          }, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_text_field, {
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.email = $event)),
                name: "email",
                required: "",
                label: "Insira seu e-mail:",
                error: _ctx.errors.email,
                onBlur: _ctx.validateEmail
              }, null, 8, ["modelValue", "error", "onBlur"]),
              _createVNode(_component_text_field, {
                modelValue: _ctx.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.password = $event)),
                type: "password",
                name: "password",
                label: "Senha:",
                required: "",
                error: _ctx.errors.password
              }, null, 8, ["modelValue", "error"])
            ]),
            (_ctx.loginErrorMessage.trim().length > 0)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_6, _toDisplayString(_ctx.loginErrorMessage), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_large_button, {
              loading: _ctx.loading,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doLogin())),
              disabled: _ctx.loading
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["loading", "disabled"]),
            _createElementVNode("h4", {
              class: "text-white text-1xl mb-4 mt-4",
              style: {"text-align":"center","cursor":"pointer"},
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.startForgetPassword && _ctx.startForgetPassword(...args)))
            }, " Esqueci minha senha "),
            _createElementVNode("h4", {
              class: "text-white text-1xl mb-4 mt-4",
              style: {"text-align":"center","cursor":"pointer"},
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.startSignUp && _ctx.startSignUp(...args)))
            }, " Não tem conta? Cadastre-se ")
          ], 2))
        : (_ctx.step === 'signup')
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["pb-8", { 'mt-16': !_ctx.showBackground }])
            }, [
              _createElementVNode("form", {
                onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitSignUp && _ctx.submitSignUp(...args)), ["prevent"])),
                class: "flex flex-col"
              }, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_text_field, {
                    modelValue: _ctx.name,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.name = $event)),
                    name: "name",
                    label: "Digite seu nome:",
                    required: "",
                    error: _ctx.errors.name,
                    onBlur: _ctx.validateName
                  }, null, 8, ["modelValue", "error", "onBlur"]),
                  _createVNode(_component_text_field, {
                    modelValue: _ctx.phone,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.phone = $event)),
                    name: "phone",
                    label: "Digite seu celular:",
                    cleave: { blocks: [2, 5, 4], numericOnly: true },
                    error: _ctx.errors.phone,
                    onBlur: _ctx.validatePhone
                  }, null, 8, ["modelValue", "error", "onBlur"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_text_field, {
                    modelValue: _ctx.email,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.email = $event)),
                    name: "email",
                    required: "",
                    label: "Insira seu e-mail:",
                    error: _ctx.errors.email,
                    onBlur: _ctx.validateEmail
                  }, null, 8, ["modelValue", "error", "onBlur"]),
                  _createVNode(_component_text_field, {
                    modelValue: _ctx.password,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.password = $event)),
                    type: "password",
                    name: "password",
                    label: "Senha:",
                    required: "",
                    error: _ctx.errors.password,
                    onBlur: _ctx.validatePassword
                  }, null, 8, ["modelValue", "error", "onBlur"]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        name: "confirmMailing",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.confirmMailing = $event)),
                        class: "leading-loose text-pink-600"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.confirmMailing]
                      ]),
                      _hoisted_13
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        name: "confirmingSMS",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.confirmingSMS = $event)),
                        class: "leading-loose text-pink-600"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.confirmingSMS]
                      ]),
                      _hoisted_16
                    ])
                  ])
                ]),
                _hoisted_17,
                (_ctx.signupErrorMessage.trim().length > 0)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_18, _toDisplayString(_ctx.signupErrorMessage), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_large_button, {
                  disabled: _ctx.loading,
                  loading: _ctx.loading,
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"]),
                _hoisted_20,
                _createElementVNode("h4", {
                  class: "text-white text-1xl mb-4 mt-4",
                  style: {"text-align":"center","cursor":"pointer"},
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.startSignIn && _ctx.startSignIn(...args)))
                }, " Já tem conta? Entre ")
              ], 32)
            ], 2))
          : (_ctx.step === 'confirmation')
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: _normalizeClass(["pb-8", { 'mt-16': !_ctx.showBackground }])
              }, [
                _hoisted_21,
                _hoisted_22,
                _hoisted_23,
                _createVNode(_component_large_button, { onClick: _ctx.startSignIn }, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ], 2))
            : (_ctx.step === 'forgetpass')
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_text_field, {
                      modelValue: _ctx.email,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.email = $event)),
                      type: "email",
                      name: "email",
                      label: "Insira seu e-mail:",
                      required: "",
                      error: _ctx.errors.email,
                      onBlur: _ctx.validateEmail
                    }, null, 8, ["modelValue", "error", "onBlur"])
                  ]),
                  (_ctx.resetResponseMsg.trim().length > 0)
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_28, _toDisplayString(_ctx.resetResponseMsg), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_large_button, {
                    loading: _ctx.loading,
                    disabled: _ctx.loading,
                    onClick: _ctx.tryToFindMail
                  }, {
                    default: _withCtx(() => [
                      _hoisted_29
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"]),
                  _createElementVNode("h4", {
                    class: "text-white text-1xl mb-4 mt-4",
                    style: {"text-align":"center","cursor":"pointer"},
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.startSignIn && _ctx.startSignIn(...args)))
                  }, " Já tem conta? Entre ")
                ]))
              : (_ctx.step === 'recoveryCode')
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_text_field, {
                        modelValue: _ctx.code,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.code = $event)),
                        type: "text",
                        name: "text",
                        label: "Insira o código de verificação:",
                        required: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_text_field, {
                        modelValue: _ctx.password,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.password = $event)),
                        type: "password",
                        name: "password",
                        label: "Insira a nova senha:",
                        error: _ctx.errors.password,
                        onBlur: _ctx.validatePassword,
                        required: ""
                      }, null, 8, ["modelValue", "error", "onBlur"])
                    ]),
                    (_ctx.resetConfirmPassMsg.trim().length > 0)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_34, _toDisplayString(_ctx.resetConfirmPassMsg), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_large_button, {
                      loading: _ctx.loading,
                      disabled: _ctx.loading,
                      onClick: _ctx.changePassword
                    }, {
                      default: _withCtx(() => [
                        _hoisted_35
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled", "onClick"])
                  ]))
                : (_ctx.step === 'genericError')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _hoisted_37,
                      _hoisted_38,
                      _createVNode(_component_large_button, { onClick: _ctx.startSignUp }, {
                        default: _withCtx(() => [
                          _hoisted_39
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
    ]),
    _hoisted_40,
    (_ctx.showBackground === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createVNode(_component_stadium_background)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.acceptedTerms)
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("button", {
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.acceptCookies())),
            class: "text-black hover:bg-primary-600 transition-colors uppercase h-6 md:h-12 w-full h-12 font-semibold tracking-widest bg-primary"
          }, " aceitar e continuar ")
        ]))
      : _createCommentVNode("", true)
  ]))
}